/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectPlanStatus = {
    Pending: 0,
    InProgress: 1,
    Completed: 2,
    Cancelled: 3
} as const;

export type ProjectPlanStatus = typeof ProjectPlanStatus[keyof typeof ProjectPlanStatus];



